export default class Locale_Main { 
	SelectAView: string = 'Select a view from the top bar..';
	GoToProject: string = 'Go to project at origin';
}